import React from 'react';
import SignatureDisplay from './SignatureDisplay';

const PreviewPanel = ({ formData, onExport, onPreview }) => {
  return (
    <div className="preview-panel">
      <h2 style={{ marginBottom: '20px', color: 'var(--text)', fontSize: '20px', fontWeight: '600' }}>
        Aperçu de la signature
      </h2>
      
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '300px',
        background: 'var(--gray-50)',
        borderRadius: 'var(--radius)',
        border: '1px solid var(--border)',
        padding: '20px',
        marginBottom: '20px'
      }}>
        <SignatureDisplay formData={formData} />
      </div>
      
      <div className="action-buttons">
        <button className="btn btn-primary" onClick={onPreview}>
          Copier la signature
        </button>
        <button className="btn btn-secondary" onClick={onExport}>
          Copier le code source
        </button>
      </div>
      
      <div style={{ 
        marginTop: '15px', 
        padding: '15px', 
        background: 'var(--gray-50)', 
        borderRadius: 'var(--radius)',
        fontSize: '13px',
        color: 'var(--text-light)',
        lineHeight: '1.5'
      }}>
        <strong>💡 Conseils d'utilisation :</strong><br />
        • Copiez le HTML et collez-le dans les paramètres de signature de votre client email<br />
        • Testez la signature dans Gmail, Outlook et Apple Mail<br />
        • Les images doivent être hébergées en ligne (Google Photos, Dropbox, etc.)
      </div>
    </div>
  );
};

export default PreviewPanel;